import { ArticleCategory } from 'types/blog';

// ==============================|| 記事カテゴリ ||============================== //
//
// 記事が増えると、1枚の一覧では「自分が知りたい分野の記事」にたどり着けなくなる。
// カテゴリごとに独立したURL(/blog/category/<slug>)を持たせて、そこを入口にする。
//
// ★ URLを独立させている理由
//   /blog?category=... のようなクエリでの絞り込みにすると、検索エンジンからは
//   すべて同じページに見えるため、カテゴリ単位で順位が付かない。
//   独立したパスにしておけば、プリレンダリングの対象になり sitemap にも載る。
//
// ★ label は types/blog.ts の ArticleCategory と同じ値にすること
//   記事データ側の category と突き合わせて絞り込むため、型で一致を保証している。
//
// ★ 記事が1本も無いカテゴリは、一覧にリンクを出さず、ページも404にする
//   中身の無いページを検索エンジンに拾わせると、サイト全体の評価を下げるため。

export type BlogCategory = {
    /** URL の末尾。/blog/category/<slug> になる */
    slug: string;
    /** 記事データの category と突き合わせる値。カードに出るラベルでもある */
    label: ArticleCategory;
    /** カテゴリページの h1。一覧の見出しより具体的に書く */
    heading: string;
    /** カテゴリページの meta description と、ページ上部の説明文 */
    description: string;
};

export const BLOG_CATEGORIES: BlogCategory[] = [
    {
        slug: 'kobetsu-shien-keikaku',
        label: '個別支援計画',
        heading: '個別支援計画の書き方と記載例',
        description:
            'アセスメントから担当者会議、文書同意、交付、モニタリングまで。個別支援計画の作成に関わる実務を、国の参考様式と記載例をもとに整理した記事をまとめています。'
    },
    {
        slug: 'unei-shido',
        label: '運営指導',
        heading: '運営指導と減算対策',
        description:
            '減算の要件と減算率、運営指導で確認される書類、記録の残し方。間違えると報酬の返還につながる論点を、条文と通知の原文つきで整理した記事をまとめています。'
    },
    {
        slug: 'kasan-hoshu',
        label: '加算・報酬改定',
        heading: '加算の算定要件と報酬改定',
        description:
            '加算ごとの算定要件と必要な記録、報酬改定で変わった点。算定できるはずの加算を取りこぼさないための情報をまとめています。'
    },
    {
        slug: 'gyomu-koritsuka',
        label: '業務効率化',
        heading: '書類業務の効率化',
        description: '児発管と管理者に集まりがちな書類業務を、どこまで仕組みに任せられるかを整理した記事をまとめています。'
    }
];

/** /blog/category/<slug> のパスを組み立てる。リンク先を手書きしないための唯一の入口 */
export const categoryPath = (slug: string) => `/blog/category/${slug}`;

/** slug からカテゴリを引く。見つからなければ undefined(ページ側で404を出す) */
export const findCategory = (slug?: string): BlogCategory | undefined => BLOG_CATEGORIES.find((category) => category.slug === slug);

/**
 * 記事データの category(ラベル)からカテゴリを引く。
 * 記事側は slug ではなくラベルを持っているため、記事ページのパンくずなどはこちらを使う。
 */
export const findCategoryByLabel = (label?: ArticleCategory): BlogCategory | undefined =>
    BLOG_CATEGORIES.find((category) => category.label === label);
